export default __webpack_public_path__ + "f996e4b1b5cd4e9660d572549fab35d9.jpg";